<template>
  <div class="callInformationManagement">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="呼入信息" name="first">
        <div class="callInformationManagement-m">
          <el-form
            :inline="true"
            :model="formsubmit"
            @keyup.enter.native.prevent="enterSearchMember(formsubmit)"
            class="demo-form-inline toolbar"
            style="padding-bottom: 0px;"
          >
            <el-form-item label="搜索内容:">
              <el-input v-model.trim="formsubmit.content" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="呼叫时间:">
              <el-date-picker
                :editable="false"
                v-model="formsubmit.orderTime"
                unlink-panels
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary"
            icon="el-icon-search"
            plain @click.native.prevent="onSubmit">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button  type="info"
            icon="el-icon-search"
            plain @click.native.prevent="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" icon="el-icon-delete" plain @click="onClear">清空查询选择</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" element-loading-text="拼命加载中......">
            <el-table
              v-loading="loading"
              :data="orderList"
              style="width: 100%"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              @selection-change="selsChange"
              highlight-current-row
            >
              <el-table-column
                label="序号"
                min-width="50"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.$index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="主叫号码"
                min-width="120"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.orderTime }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="客户姓名"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.customerName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="被叫号码"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="接单人员"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.orderPeople }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫起始时间"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.startTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫结束时间"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.endTime}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫时长"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px"></span>
                  <span style="margin-left: 10px">{{ scope.row.callTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="接听状态"
                min-width="100" 
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px"></span>
                  <span style="margin-left: 10px">{{ scope.row.callStatus }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="录音"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span><img src="@/assets/callcenter/sounds.png" alt="" class="handedness" style="margin-right:0px;width:12px;height:12px;vertical-align: middle;"></span>
                  <span>{{ scope.row.sounds }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout="total, prev, pager, next"
              :total="totalDataNumber"
              :page-size="pageSize"
              align="center"
              class="fenye"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="呼出信息" name="second">
        <div class="callInformationManagement-m">
          <el-form
            :inline="true"
            :model="formsubmit"
            @keyup.enter.native.prevent="enterSearchMember(formsubmit)"
            class="demo-form-inline toolbar"
            style="padding-bottom: 0px;"
          >
            <el-form-item label="搜索内容:">
              <el-input v-model.trim="formsubmit.content" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="呼叫时间:">
              <el-date-picker
                :editable="false"
                v-model="formsubmit.orderTime"
                unlink-panels
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
            icon="el-icon-search"
            plain @click.native.prevent="onSubmit">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="info"
            icon="el-icon-search"
            plain @click.native.prevent="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" icon="el-icon-delete" plain @click="onClear">清空查询选择</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" element-loading-text="拼命加载中......">
            <el-table
              v-loading="loading"
              :data="orderList"
              style="width: 100%"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              @selection-change="selsChange"
              highlight-current-row
            >
              <el-table-column
                label="序号"
                min-width="50"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.$index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="主叫号码"
                min-width="120"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.phone }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="客户姓名"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.customerName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="被叫号码"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.orderTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="接单人员"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.orderPeople }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫起始时间"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.startTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫结束时间"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.endTime}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫时长"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px"></span>
                  <span style="margin-left: 10px">{{ scope.row.callTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="接听状态"
                min-width="100" 
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px"></span>
                  <span style="margin-left: 10px">{{ scope.row.callStatus }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="录音"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span><img src="@/assets/callcenter/sounds.png" alt="" class="handedness" style="margin-right:2px;width:12px;height:12px;vertical-align: middle;"></span>
                  <span>{{ scope.row.sounds }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout="total, prev, pager, next"
              :total="totalDataNumber"
              :page-size="pageSize"
              align="center"
              class="fenye"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="呼叫量统计" name="third">
        <div class="callInformationManagement-m">
          <el-form
            :inline="true"
            :model="formsubmit"
            @keyup.enter.native.prevent="enterSearchMember(formsubmit)"
            class="demo-form-inline toolbar"
            style="padding-bottom: 0px;"
          >
            <el-form-item label="搜索内容:">
              <el-input v-model.trim="formsubmit.content" placeholder="请输入" style="width:200px"></el-input>
            </el-form-item>
            <el-form-item label="呼叫类型:">
              <el-select v-model="formsubmit.callType" clearable placeholder="请选择工单类型" filterable>
                <el-option
                  style="width:200px"
                  v-for="(item,index) in callTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="呼叫时间:">
              <el-date-picker
                style="width:200px"
                :editable="false"
                v-model="formsubmit.orderTime"
                unlink-panels
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
            icon="el-icon-search"
            plain @click.native.prevent="onSubmit">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="info"
            icon="el-icon-search"
            plain @click.native.prevent="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" icon="el-icon-delete" plain @click="onClear">清空查询选择</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" element-loading-text="拼命加载中......">
            <el-table
              v-loading="loading"
              :data="callStatisticsList"
              style="width: 100%"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              highlight-current-row
            >
              <el-table-column
                label="序号"
                min-width="50"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.$index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫时间"
                min-width="120"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.callTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="接单人员"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.orderPeople }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫次数"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.orderFrequency }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="接通次数"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.switchFrequency}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="呼叫类型"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.callType }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="接通率"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.callComplete }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="总通话时长"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.totalTime }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="平均通话时长"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px"></span>
                  <span style="margin-left: 10px">{{ scope.row.averageTime }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChangeThree"
              @current-change="handleCurrentChangeThree"
              :current-page="currentPageThree"
              layout="total, prev, pager, next"
              :total="totalDataNumberThree"
              :page-size="pageSizeThree"
              align="center"
              class="fenye"
            ></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  data() {
    return {
      activeName: "first",
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      orderList: [
        {
          orderTime: "15926105967",
          orderNo: "朱兆芳",
          customerName: "朱兆芳",
          phone: "027-84021108",
          startTime: "2023/08/23 16:22:30",
          endTime: "2023/08/23 16:29:30",
          callTime: "0:07:00",
          callStatus: "已接通",
          orderPeople: "云新建",
          sounds: "播放录音"
        },
        {
          orderTime: "13972303561",
          orderNo: "李建国",
          customerName: "李建国",
          phone: "027-84021108",
          startTime: "2023/08/23 15:35:40",
          endTime: "2023/08/23 15:40:40",
          callTime: "0:05:00",
          callStatus: "已接通",
          orderPeople: "章慧嘉",
          sounds: "播放录音"
        },
        {
          orderTime: "15971688892",
          orderNo: "邱秀珍",
          customerName: "邱秀珍",
          phone: "027-84021108",
          startTime: "2023/08/23 11:02:10",
          endTime: "2023/08/23 11:12:10",
          callTime: "0:10:00",
          callStatus: "已接通",
          orderPeople: "柏忠林",
          sounds: "播放录音"
        },
        {
          orderTime: "18971265320",
          orderNo: "占中秋",
          customerName: "占中秋",
          phone: "027-84021108",
          startTime: "2019/11/22 14:54:25",
          endTime: "0:06:00",
          callTime: "0:07:00",
          callStatus: "已接通",
          orderPeople: "邹文杰",
          sounds: "播放录音"
        },
        {
          orderTime: "17764052563",
          orderNo: "李爱兰",
          customerName: "李爱兰",
          phone: "027-84021108",
          startTime: "2019/11/22 12:22:30",
          endTime: "2019/11/22 12:30:30",
          callTime: "0:08:00",
          callStatus: "已接通",
          orderPeople: "戚淑慧",
          sounds: "播放录音"
        },
      ],
      orderListOne: [
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "李四",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        }
      ],
      orderListTwo: [
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "王五",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        }
      ],
      orderListThree: [
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "赵六",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "赵六",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "赵六",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        },
        {
          orderTime: "13129983456",
          orderNo: "李三四",
          customerName: "赵六",
          phone: "027-84021108",
          startTime: "2019-11-24 14:09:24",
          endTime: "2019-11-24 14:12:56",
          callTime: "01:13:09",
          callStatus: "已接通",
          orderPeople: "王五",
          sounds: "播放录音"
        }
      ],
      sels: [], //列表选中列的checkbox集合
      totalDataNumber: 5, //数据的总数,
      loading: "", //加载数据中
      //查询传入的参数
      formsubmit: {
        content: "",
        orderTime: "",
        orderType: ""
      },
      dealStatusList: [
        {
          value: "0",
          label: "未处理"
        },
        {
          value: "1",
          label: "处理中"
        },
        {
          value: "2",
          label: "已处理"
        },
        {
          value: "3",
          label: "已回访"
        }
      ],
      callTypeList: [
        {
          value: "0",
          label: "呼入"
        },
        {
          value: "1",
          label: "呼出"
        }
      ],
      orderPeopleList: [
        {
          value: "0",
          label: "张三"
        },
        {
          value: "1",
          label: "李四"
        },
        {
          value: "2",
          label: "王五"
        },
        {
          value: "3",
          label: "赵六"
        }
      ],
      //element-ui 日期选择器如何限制只能选择一个月，超过一个月不能选择，也就是在选定起始日期时，只能向后面选择30天，同时不能选择超过今天的日期
      pickerMinDate: "",
      dateRange: [],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      },
      pickerServiceTime: {
        disabledDate(time) {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        }
      },
      currentPageThree: 1, //初始页
      pageNumThree: 1, //页码
      pageSizeThree: 10, //每页显示的条数
      totalDataNumberThree: 5, //数据的总数,
      callStatisticsList: [
        {
          callTime: "2023/08/23 16:50:30",
          orderPeople: "云新建",
          orderFrequency: "5",
          switchFrequency: "5",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:30:20"
        },
        {
          callTime: "2023/08/23 16:05:40",
          orderPeople: "章慧嘉",
          orderFrequency: "7",
          switchFrequency: "7",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "00:42:33",
          averageTime: "00:20:20"
        },
        {
          callTime: "2019/11/22 12:02:10",
          orderPeople: "柏忠林",
          orderFrequency: "10",
          switchFrequency: "10",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "00:33:13",
          averageTime: "00:15:20"
        },
         {
          callTime: "2019/11/22 15:54:25",
          orderPeople: "邹文杰",
          orderFrequency: "5",
          switchFrequency: "5",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "00:55:13",
          averageTime: "00:23:20"
        },
        {
          callTime: "2019/11/21 14:22:30",
          orderPeople: "戚淑慧",
          orderFrequency: "13",
          switchFrequency: "13",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "00:52:23",
          averageTime: "00:27:30"
        },
      ],
      callStatisticsListOne: [
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        }, 
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        }
      ],
      callStatisticsListTwo: [
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        }, 
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        }
      ],
      callStatisticsListThree: [
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        },
        {
          callTime: "2019-11-24",
          orderPeople: "张三",
          orderFrequency: "15",
          switchFrequency: "15",
          callType: "呼入",
          callComplete: "100%",
          totalTime: "01:12:23",
          averageTime: "00:10:20"
        }
      ]
    };
  },
  methods: {
    //选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },
    //清空 重置选取的值
    onClear() {
      this.formsubmit = {
        content: "",
        orderTime: "",
        orderType: ""
      };
    },

    //点击查询
    onSubmit() {},

    //键盘事件 按下键盘回车 查询
    enterSearchMember(formsubmit) {},

    /* 
      选项卡的点击
    */
    handleClick(tab, event) {
      console.log(tab, event);
    },

    /* 
      接单时间的change
    */
    changeServiceTime(val) {
      console.log(val);
      this.dataForm.orderTime = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log(this.dataForm.orderTime);
    },

    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
     // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      // return this.rowStyle;
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    // 修改table header的背景色
    tableHeaderColorThree({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#dcdfe6;color:#6f7075;font-weight: 500;";
      }
    },

    //关闭处理报警dialog的回调
    closeDealAlarm() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警取消按钮
    cancelDealAlarm() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警记录 弹出dialog框
    handleDeal(index, row) {
      console.log(index, row);
      this.form = Object.assign({}, row);
      console.log(this.form);
      this.dialogFormVisible = true;
    },

    //选择的勾选的列
    selsChange: function(sels) {
      this.sels = sels;
      console.log(sels);
    },

    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      if (this.pageNum == 1) {
        this.orderList = this.orderListOne;
      } else if (this.pageNum == 2) {
        this.orderList = this.orderListTwo;
      } else if (this.pageNum == 3) {
        this.orderList = this.orderListThree;
      }
    },

    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChangeThree(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.pageSizeThree = val;
    },
    handleCurrentChangeThree(val) {
      console.log(`当前页: ${val}`);
      this.pageNumThree = val;
      if (this.pageNumThree == 1) {
        this.callStatisticsList = this.callStatisticsListOne;
      } else if (this.pageNumThree == 2) {
        this.callStatisticsList = this.callStatisticsListTwo;
      } else if (this.pageNumThree == 3) {
        this.callStatisticsList = this.callStatisticsListThree;
      }
    }
  },
  watch: {
    currentPage(oldV, newV) {
      console.log(oldV, newV);
    }
  },

  created() {},

  mounted() {
    //this.orderList = this.orderListOne;
    //this.callStatisticsList = this.callStatisticsListOne;
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
// .callInformationManagement {
//   .callInformationManagement-m {
//     // padding: 0px 0 0 5px;
//   }
// }
.fenye {
  padding: 30px 0;
  background: #fff;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//处理报警记录的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .dealalarm .el-dialog {
    width: 30% !important;
  }
}
</style>


